// Appcues video integration
/*
<---- Object example ---->

featurename:{
  id (Apcues Flow id),
  article (Url for support article),
  articleId ,
  guideVideoLabel (i18key for custom video label name) ,
  guideArticleLabel (i18key for custom article label name) ,
  tooltipInfoVideo (i18key for video icon tooltip) ,
  tooltipInfoArticle (i18key for article icon tooltip)
  videoLink: link to any external url
} */

export const featureIdentifyObj = {
  softwarebundle: {
    // object convention Key should be Url of the page name
    id: 'softwareBundle',
    appcuseId: '70afb8c8-a97a-44d9-972b-23430a7f64c1', // Appcuse flow id
    article:
      'https://support.superops.ai/en/articles/6632104-how-to-use-third-party-software-management-in-superops-ai',
    articleId: 6632104 // Article id
  },
  report: {
    id: 'reportsPreview', // Appcuse flow id
    appcuseId: 'ea8ab7d6-82c5-4507-978b-1e3ed4e83bb5',
    article: 'https://support.superops.ai/en/articles/6648723-creating-reports',
    articleId: 6648723,
    guideVideoLabel: 'guide.video.label.reporting'
  },
  defaultpdfreport: {
    id: 'reportsPreview',
    appcuseId: 'ea8ab7d6-82c5-4507-978b-1e3ed4e83bb5', // Appcuse flow id
    article:
      'https://support.superops.ai/en/articles/7262030-all-about-pdf-reports',
    articleId: 7262030
  },
  datareport: {
    id: 'reportsPreview',
    appcuseId: 'ea8ab7d6-82c5-4507-978b-1e3ed4e83bb5', // Appcuse flow id
    article:
      'https://support.superops.ai/en/articles/7843787-working-with-data-reports',
    articleId: 7843787
  },
  efficiencyreport: {
    id: 'efficiencyReport',
    article:
      'https://support.superops.com/en/articles/9100087-smart-tracker-resource-utilization-and-efficiency-reports',
    articleId: 9100087
  },
  profile: {
    id: '',
    article:
      'https://support.superops.ai/en/articles/6642794-setting-up-your-profile-information',
    articleId: 6642794
  },
  twofactorauth: {
    id: '',
    article:
      'https://support.superops.ai/en/articles/6642915-enabling-two-factor-authentication',
    articleId: 6642915
  },
  mspinformation: {
    id: '',
    article:
      'https://support.superops.ai/en/articles/6642920-adding-your-msp-s-information',
    articleId: 6642920
  },
  domainandemail: {
    id: 'customMailBox',
    appcuseId: 'a2568b6d-fc5e-4bba-b8fa-956deb2a7a15',
    article:
      'https://support.superops.ai/en/articles/6963191-setting-up-and-using-mailboxes-in-superops-ai',
    guideVideoLabel: 'guide.video.label.custommailbox',
    articleId: 6642922
  },
  holidaymanagement: {
    id: '',
    article:
      'https://support.superops.ai/en/articles/6642925-setting-up-holiday-management',
    articleId: 6642925
  },
  technicianroles: {
    id: '',
    article:
      'https://support.superops.ai/en/articles/6642957-setting-up-technician-roles',
    articleId: 6642957
  },
  requesterroles: {
    id: '',
    article:
      'https://support.superops.ai/en/articles/6642976-setting-up-requester-roles',
    articleId: 6642976
  },
  techniciangroups: {
    id: '',
    article:
      'https://support.superops.ai/en/articles/6642973-creating-technician-groups',
    articleId: 6642973
  },
  status: {
    id: '',
    article:
      'https://support.superops.ai/en/articles/6648707-managing-ticket-statuses',
    articleId: 6648707
  },
  prioritymatrix: {
    id: '',
    article: 'https://support.superops.ai/en/articles/6648710-priority-matrix',
    articleId: 6648710
  },
  category: {
    id: '',
    article:
      'https://support.superops.ai/en/articles/6648714-ticket-categories-and-subcategories',
    articleId: 6648714
  },
  cause: {
    id: '',
    article: 'https://support.superops.ai/en/articles/6648718-ticket-cause',
    articleId: 6648718
  },
  resolutioncodes: {
    id: '',
    article: 'https://support.superops.ai/en/articles/6648720-resolution-codes',
    articleId: 6648720
  },
  slapolicies: {
    id: '',
    article: 'https://support.superops.ai/en/articles/6648695-creating-an-sla',
    articleId: 6648695
  },
  slaconfigurations: {
    id: '',
    article:
      'https://support.superops.ai/en/articles/6648697-configuring-and-managing-your-slas',
    articleId: 6648697
  },
  eventtriggers: {
    id: 'ticketAutomation',
    appcuseId: '35d9e61d-fc3b-4dd9-ba9f-da1a40064863',
    article:
      'https://support.superops.ai/en/articles/6632292-setting-up-event-triggers',
    articleId: 6632292,
    guideVideoLabel: 'guide.video.label.eventtriggers'
  },
  timetriggers: {
    id: 'ticketAutomation',
    appcuseId: '35d9e61d-fc3b-4dd9-ba9f-da1a40064863',
    article:
      'https://support.superops.ai/en/articles/6632301-setting-up-time-triggers',
    articleId: 6632301,
    guideVideoLabel: 'guide.video.label.timetriggers'
  },
  policymanagement: {
    id: 'policyManagement',
    appcuseId: '4e1bae91-a44d-4bff-841e-7e4a59f6bbf1',
    article:
      'https://support.superops.ai/en/articles/6632383-getting-started-with-policy-management',
    articleId: 6632383,
    guideVideoLabel: 'guide.video.label.policymanagement'
  },
  runbooks: {
    id: 'runbook',
    appcuseId: '70d7334e-c9f9-4ff5-90d9-2bd7336ff18c',
    article: 'https://support.superops.ai/en/articles/6648736-runbooks',
    articleId: 6648736,
    tooltipInfoVideo: 'guide.tooltip.runbooks',
    guideVideoLabel: 'guide.video.label.runbooks'
  },
  technicianlogin: {
    id: '',
    article:
      'https://support.superops.ai/en/articles/6648747-technician-logins',
    articleId: 6648747
  },
  requesterlogin: {
    id: '',
    article: 'https://support.superops.ai/en/articles/6648749-requester-logins',
    articleId: 6648749
  },
  sessionsettings: {
    id: '',
    article: 'https://support.superops.ai/en/articles/6648752-session-timeouts',
    articleId: 6648752
  },
  iprestrictions: {
    id: '',
    article: 'https://support.superops.ai/en/articles/6648753-ip-restrictions',
    articleId: 6648753
  },
  customersupportaccess: {
    id: '',
    article:
      'https://support.superops.ai/en/articles/6632444-a-quick-guide-to-customer-support-access',
    articleId: 6632444
  },
  systemtrayicon: {
    id: '',
    article:
      'https://support.superops.ai/en/articles/6951521-managing-your-agent-and-system-tray',
    articleId: 6951521
  },
  csatsurveys: {
    id: '',
    article: 'https://support.superops.ai/en/articles/6648737-csat-surveys',
    articleId: 6648737
  },
  customfields: {
    id: '',
    article:
      'https://support.superops.ai/en/articles/7872605-all-about-ticket-fields',
    articleId: 7872605
  },
  itdocumentation: {
    id: '',
    article:
      'https://support.superops.ai/en/articles/6648694-creating-it-document-categories',
    articleId: 6648694
  },
  assetclass: {
    id: '',
    article:
      'https://support.superops.ai/en/articles/6632048-setting-up-custom-fields-for-monitored-assets',
    articleId: 6632048
  },
  'asset-automation': {
    id: '',
    article: 'https://support.superops.ai/en/articles/asset-automation-guide',
    articleId: null
  },
  ticketscheduler: {
    id: 'ticketAutomation',
    appcuseId: '35d9e61d-fc3b-4dd9-ba9f-da1a40064863',
    article: 'https://support.superops.ai/en/articles/6714728-ticket-scheduler',
    articleId: 6714728,
    guideVideoLabel: 'guide.video.label.ticketscheduler'
  },
  invoicesettings: {
    id: 'allInvoices',
    appcuseId: '8f2b0da4-c11f-4280-8c94-ccafb54ad59f',
    article:
      'https://support.superops.ai/en/articles/6642955-generating-an-invoice#h_2993e3e637',
    articleId: 6642955,
    guideVideoLabel: 'guide.video.label.invoicesettings'
  },
  timetracking: {
    id: '',
    article:
      'https://support.superops.ai/en/articles/6642936-configuring-time-tracking',
    articleId: 6642936
  },
  servicecatalog: {
    id: '',
    article:
      'https://support.superops.ai/en/articles/6642912-the-service-catalog-explained',
    articleId: 6642912
  },
  emailnotification: {
    id: '',
    article:
      'https://support.superops.com/en/articles/8446254-how-notifications-work-in-superops-ai',
    articleId: 6737201
  },
  technician: {
    id: '',
    article: 'https://support.superops.ai/en/articles/6737676-add-technicians',
    articleId: 6737676
  },
  allinvoice: {
    id: 'allInvoices',
    article:
      'https://support.superops.ai/en/articles/6642955-generating-an-invoice',
    articleId: 6642955,
    guideVideoLabel: 'guide.video.label.allinvoices'
  },
  patchmanagement: {
    id: 'patchManagement',
    appcuseId: 'd1d7db98-71b1-45cb-820d-7201a38b4815',
    tooltipInfoVideo: 'guide.tooltip.patchmanagement'
  },
  stripeintegration: {
    id: 'stripeIntegration',
    appcuseId: '6c7eeefd-d187-412f-b829-66005ba53b57',
    guideVideoLabel: 'guide.video.label.stripe'
  },
  flexPointIntegration: {
    appcuseId: '377d1942-6127-4096-b962-c4a3ecf98d79',
    article:
      'https://support.superops.com/en/articles/9857737-integrating-flexpoint-with-superops',
    articleId: 9857737
  },
  alternativePaymentsIntegration: {
    appcuseId: '377d1942-6127-4096-b962-c4a3ecf98d79',
    article:
      'https://support.superops.com/en/articles/9858098-integrating-alternative-payments-with-superops',
    articleId: 9858098
  },
  azureintegration: {
    id: 'azureIntegartion',
    appcuseId: '272e5e6a-a907-4d2c-964f-6c6bf5758ce5',
    guideVideoLabel: 'guide.video.label.azure'
  },
  splashtopintegration: {
    id: 'teamViewer',
    appcuseId: '50438c4d-1f62-43a3-a66b-30f4b059c924',
    guideVideoLabel: 'guide.video.label.splashtop'
  },
  teamviewerintegration: {
    id: 'teamViewer',
    appcuseId: '50438c4d-1f62-43a3-a66b-30f4b059c924',
    guideVideoLabel: 'guide.video.label.teamviewer'
  },
  connectwiseintegration: {
    id: 'teamViewer',
    appcuseId: '50438c4d-1f62-43a3-a66b-30f4b059c924',
    guideVideoLabel: 'guide.video.label.connectwise'
  },
  xerointegration: {
    appcuseId: '377d1942-6127-4096-b962-c4a3ecf98d79',
    article:
      'https://support.superops.com/en/articles/9515555-how-to-integrate-xero-with-superops',
    articleId: 9515555
  },
  quickbooksintegration: {
    appcuseId: '377d1942-6127-4096-b962-c4a3ecf98d79',
    article:
      'https://support.superops.com/en/articles/6632156-how-to-integrate-quickbooks-online-with-superops',
    articleId: 6632156
  },
  assetdetails: {
    id: 'assetWorklog',
    appcuseId: '1e02246a-ec1a-44ca-8130-201045a48f65',
    tooltipInfoVideo: 'guide.tooltip.assetdetails'
  },
  agentdownload: {
    id: 'downloadAgent',
    appcuseId: 'f06e6598-f8a7-4766-b9e3-93e1da799644',
    guideVideoLabel: 'guide.video.label.agentdownload',
    articleId: 6632028,
    article:
      'https://support.superops.com/en/articles/6632028-how-to-download-and-deploy-the-agent'
  },
  ticketlistandkanban: {
    id: 'ticketKanban',
    appcuseId: 'd8548318-8f0a-4f19-a270-6cd99a913739',
    tooltipInfoVideo: 'guide.tooltip.ticketlistandkanban'
  },
  creatingticket: {
    id: 'createTicket',
    appcuseId: 'e665d0aa-9ae9-4371-94f5-877a4405f78e',
    tooltipInfoVideo: 'guide.tooltip.creatingticket'
  },
  projectmanagement: {
    id: 'projectManagement',
    appcuseId: 'f1fb92d4-6a11-4e53-88fc-e77001bb8203',
    tooltipInfoVideo: 'guide.tooltip.projectmanagement'
  },
  invoiceauditandbilling: {
    id: 'invoiceAudit',
    appcuseId: '6711d958-2222-49d9-969f-7906f80d473c',
    tooltipInfoVideo: 'guide.tooltip.invoiceauditandbilling'
  },
  quoting: {
    id: 'quoting',
    appcuseId: '385385c5-7a54-48a8-bc2d-cf51afee3367',
    tooltipInfoVideo: 'guide.tooltip.quoting'
  },
  clients: {
    id: 'importClient',
    appcuseId: '00817823-bd2a-4be7-9574-8b98d7a057f0',
    tooltipInfoVideo: 'guide.tooltip.clients'
  },
  salesinbox: {
    id: 'salesInbox',
    appcuseId: '140b88bf-5e1a-4b67-9bff-e047ed30988d',
    tooltipInfoVideo: 'guide.tooltip.salesinbox'
  },
  itdocumentationlist: {
    id: 'itDoc',
    appcuseId: 'f505e76c-d128-43e1-8089-8240a904871d',
    tooltipInfoVideo: 'guide.tooltip.itdocumentationlist'
  },
  pax8integration: {
    id: 'pax8Integration',
    appcuseId: '7844f174-4e36-449a-8223-355e548e51a2',
    guideVideoLabel: 'guide.video.label.pax8'
  },
  halopsaintegration: {
    id: 'haloIntegration',
    appcuseId: 'c3335bbc-d70c-4872-b97e-02c2b3543157',
    guideVideoLabel: 'guide.video.label.halopsa'
  },
  sentineloneintegration: {
    id: 'sentinelOne',
    appcuseId: 'c95d9d40-34f4-470a-851f-127853fd9f55',
    guideVideoLabel: 'guide.video.label.sentinelone',
    article:
      'https://support.superops.ai/en/articles/7234250-how-to-integrate-sentinelone-with-superops-ai',
    articleId: 7234250
  },
  threatdownintegration: {
    article:
      'https://support.superops.com/en/articles/10174331-how-to-integrate-threatdown-with-superops',
    articleId: 10174331
  },
  huduintegration: {
    id: 'huduIntegartion',
    appcuseId: 'ae7f8127-a485-4156-8c21-e1e21ea98a92',
    guideVideoLabel: 'guide.video.label.hudu',
    article:
      'https://support.superops.ai/en/articles/7236702-how-to-integrate-hudu-with-superops-ai',
    articleId: 7236702
  },
  itglueintegration: {
    // id: 'itglueintegration',
    article:
      'https://support.superops.com/en/articles/10530768-how-to-integrate-it-glue-with-superops',
    articleId: 10530768
  },
  islIntegration: {
    // id: 'islIntegration',
    article:
      'https://support.superops.com/en/articles/10501894-how-to-integrate-isl-online-with-superops',
    articleId: 1053234543
  },
  groupbasedpolicy: {
    id: 'groupBasedPolicyManagement',
    appcuseId: '7f503300-94f2-4b15-83fa-7427a9d3d2cb',
    tooltipInfoVideo: 'guide.tooltip.groupbasedpolicy'
  },
  assetmigration: {
    article:
      'https://support.superops.ai/en/articles/8306531-migrating-your-assets-into-superops-ai-using-scripts',
    articleId: 8306531,
    guideArticleLabel: 'guide.tooltip.assetmigration'
  },
  timesheet: {
    id: 'timeSheet',
    article: 'https://support.superops.ai/en/collections/7197986-smart-tracker'
  },
  networkProbe: {
    id: 'networkProbe',
    guideArticleLabel: 'guide.tooltip.assetmigration',
    article:
      'https://support.superops.com/en/articles/8296945-adding-a-probe-in-superops-ai',
    articleId: 8296945,
    guideVideoLabel: 'guide.video.label.eventtriggers'
  },
  networkScan: {
    id: 'networkScan',
    guideArticleLabel: 'guide.tooltip.assetmigration',
    article:
      'https://support.superops.com/en/articles/8296963-running-network-scans',
    articleId: 8296963,
    guideVideoLabel: 'guide.video.label.eventtriggers'
  },
  networkSubnet: {
    id: 'networkSubnet',
    guideArticleLabel: 'common.article',
    article:
      'https://support.superops.com/en/articles/8296955-managing-your-subnets-in-superops-ai',
    articleId: 8296955,
    guideVideoLabel: 'common.video'
  },
  networkCredentials: {
    id: 'networkCredentials',
    guideArticleLabel: 'common.article',
    article:
      'https://support.superops.com/en/articles/8296949-setting-up-snmp-credentials-in-superops-ai',
    articleId: 8296955,
    guideVideoLabel: 'common.video'
  },
  networkCustomMonitors: {
    id: 'networkCustomMonitors',
    guideArticleLabel: 'common.article',
    article:
      'https://support.superops.ai/en/articles/8296982-getting-the-best-out-of-monitors',
    articleId: 8296955,
    guideVideoLabel: 'common.video'
  },
  aiTicket: {
    id: 'aiSummary',
    article:
      'https://support.superops.com/en/articles/9064192-ai-summarization-in-superops',
    articleId: 8296955
  },
  advancedPolicy: {
    id: 'advancedPolicy',
    article:
      'https://support.superops.com/en/articles/9790411-how-to-import-policies-from-group-based-to-advanced-policy-early-access',
    videoLink: 'https://www.youtube.com/watch?v=CEFzB_n1HoU',
    articleId: 9790411
  },
  maintenanceMode: {
    article:
      'https://support.superops.com/en/articles/10221765-maintenance-mode',
    articleId: 10221765
  },
  scheduling: {
    id: 'scheduling',
    article:
      'https://support.superops.com/en/articles/9162522-scheduling-in-superops',
    guideVideoLabel: 'common.video'
  },
  networkMonitoringProbe: {
    id: 'networkMonitoringProbe',
    guideVideoLabel: 'common.video'
  },
  gpo: {
    articleId: 9516286,
    article:
      'https://support.superops.com/en/articles/9516286-bulk-deployment-using-gpo'
  },
  intune: {
    articleId: 8010333,
    article:
      'https://support.superops.com/en/articles/8010333-deployment-using-microsoft-intune'
  },
  silentInstaller: {
    articleId: 6632071,
    article:
      'https://support.superops.com/en/articles/6632071-how-to-install-the-superops-agent-silently-using-scripts'
  },
  esetintegration: {
    articleId: 9398995,
    article:
      'https://support.superops.com/en/articles/9398995-how-to-integrate-superops-with-eset'
  },
  monicaAI: {
    id: 'monicaAI',
    article: 'https://support.superops.com/en/collections/10699372-ai-features',
    videoLink: ' https://app.storylane.io/share/0oygh7af0dme'
  },
  exiumIntegration: {
    articleId: 6632071,
    article:
      'https://support.superops.com/en/articles/10199696-how-to-integrate-exium-with-superops'
  },
  dropsuiteIntegration: {
    articleId: 10434439,
    article:
      'https://support.superops.com/en/articles/10434439-how-to-integrate-dropsuite-with-superops'
  },
  sophosIntegration: {
    articleId: 10230487,
    article:
      'https://support.superops.com/en/articles/10230487-how-to-integrate-sophos-with-superops'
  },
  'contract.recurring': {
    id: 'recurringContract'
  },
  'contract.usageBased': {
    id: 'usage'
  },
  'contract.oneTime': {
    id: 'oneTime'
  },
  'contract.timeAndMaterial': {
    id: 'timeAndMaterial'
  },
  unifiedRunbookList: {
    id: 'unifiedRunbooks',
    guideArticleLabel: 'common.article',
    article:
      'https://support.superops.com/en/articles/10709582-configuring-unified-runbooks',
    articleId: 10709582,
    videoLink:
      'https://superops.clueso.io/embed/846b6317-6f73-4cee-b389-6afaafa4d16e'
  },
  'contract.productAndServices': {
    id: 'productAndServices',
    article:
      'https://support.superops.com/en/articles/10469430-creating-a-new-service-item-in-superops'
  },
  'script.ai': {
    id: 'scriptAi',
    article:
      'https://support.superops.com/en/articles/11018649-beta-generate-scripts-with-monica',
    articleId: 11018649
  },
  huntressintegration: {
    // article: 'https://superops.com',   // enable this when article is available
    // articleId: 1053234544
  },
  axcientIntegration: {
    article: 'https://support.superops.com/en/articles',
    articleId: 11018650
  },
  slackintegration: {
    id: 'slackintegration',
    articleId: 12035022,
    itArticle:
      'https://support.superops.com/it/en/articles/12035022-integrating-slack-with-superops',
    article:
      'https://support.superops.com/en/articles/12648084-how-to-set-up-slack-and-ms-teams-notifications',
    videoLink: 'https://www.youtube.com/watch?v=MaPS_Lld_9Y'
  },
  msteamsintegration: {
    id: 'msteamsintegration',
    articleId: 12397825,
    itArticle:
      'https://support.superops.com/it/en/articles/12397825-integrating-ms-teams-with-superops',
    article:
      'https://support.superops.com/en/articles/12648084-how-to-set-up-slack-and-ms-teams-notifications',
    videoLink: 'https://youtu.be/GWv-oEfZML4'
  },
  mdmConfiguration: {
    article:
      'https://support.superops.com/en/articles/12638599-how-to-set-up-apple-device-with-an-apn-certificate',
    articleId: 1234567,
    guideArticleLabel: 'Apple Guide'
  },
  mdmAndriodConfiguration: {
    article:
      'https://support.superops.com/it/en/articles/12646738-how-to-set-up-android-enterprise-for-mdm',
    articleId: 12646809,
    guideArticleLabel: 'Android Guide'
  },
  mdmAndroidPolicies: {
    article:
      'https://support.superops.com/en/articles/12646809-configure-device-restriction-policies-for-android-enterprise-devices',
    articleId: 12646738
  },
  mdmIosPolicies: {
    article:
      'https://support.superops.com/en/articles/12639024-how-to-configure-ios-and-ipados-device-restrictions',
    articleId: 1234569
  },
  mspMdmConfigurations: {
    article:
      'https://support.superops.com/en/collections/16467325-mobile-device-management-early-access',
    articleId: 1234567,
    guideArticleLabel: 'common.article'
  }
};
